import { useLocation } from "react-router-dom";
import translations from "./translations";

export const LANGS = ["en", "fr", "ar"];
export const DEFAULT_LANG = "en";
export const RTL_LANGS = ["ar"];
export const LANG_NAMES = { en: "EN", fr: "FR", ar: "AR" };
export const OG_LOCALE = { en: "en_US", fr: "fr_FR", ar: "ar_MA" };

export const isValidLang = (lang) => LANGS.includes(lang);
export const isRTL = (lang) => RTL_LANGS.includes(lang);

// current language from the first path segment (defaults to en)
export function getLang(pathname) {
  const seg = (pathname || "/").split("/")[1];
  return isValidLang(seg) ? seg : DEFAULT_LANG;
}

// language-agnostic logical path: "" for home, "/projects", "/projects/slug", ...
export function stripLang(pathname) {
  const parts = (pathname || "/").split("/");
  if (isValidLang(parts[1])) parts.splice(1, 1);
  const p = parts.join("/").replace(/\/+$/, "");
  return p === "" ? "" : p;
}

// build a localized href from a logical path, e.g. ("/projects", "fr") -> "/fr/projects"
export const langPath = (path, lang) => `/${lang}${path || ""}`;

export function useLang() {
  return getLang(useLocation().pathname);
}

export function useLogicalPath() {
  return stripLang(useLocation().pathname);
}

export function useTranslations() {
  const lang = getLang(useLocation().pathname);
  return translations[lang] || translations.en;
}
